import { createFlatRequest } from '@zc-react-admin/axios';

import { getServiceBaseURL } from '@/utils/service';

import { backEndFail, handleError } from './error';
import { getAuthorization } from './shared';
import type { RequestInstanceState } from './type';

const isHttpProxy = import.meta.env.DEV && import.meta.env.VITE_HTTP_PROXY === 'Y';
const { baseURL } = getServiceBaseURL(import.meta.env, isHttpProxy);
export const request = createFlatRequest<App.Service.Response, RequestInstanceState>(
  {
    baseURL,
    headers: {}
  },
  {
    isBackendSuccess(response) {
      return import.meta.env.VITE_SERVICE_SUCCESS_CODE.split(',').includes(String(response.data.code));
    },
    async onBackendFail(response, instance) {
      await backEndFail(response, instance, request);
    },
    onError(error) {
      handleError(error, request);
    },
    async onRequest(config) {
      const Authorization = getAuthorization();
      Object.assign(config.headers, { Authorization });

      return config;
    },
    transformBackendResponse(response) {
      const data = response.data.data as any;
      if (data?.meta?.pagination) {
        const pagination = data.meta.pagination as Entity.PaginationDto;
        const listData: PaginationList<any> = {
          limit: pagination.per_page,
          list: data.data,
          page: pagination.current_page,
          total: pagination.total,
          totalPage: pagination.total_pages
        };
        return listData;
      }
      return data;
    }
  }
);
